// tslint:disable
import * as React from 'react';

export class Confirm extends React.Component<any, any> {
    public onConfirm(){
        this.props.CONFIG.onConfirm();
        this.props.CONFIG.onClose();
    }

    public onCancel(){
        if (this.props.CONFIG.onCancel) {
            return this.props.CONFIG.onCancel();
        }
        return this.props.config.onClose();
    }

    render(){
        return(
            <div className="row p-5">
                <div id="page-title" className="col-xs-12">
                    <h2>
                        {this.props.CONFIG.modalTitle || 'Please confirm your action!'}
                    </h2>
                </div>
                <div className="col-xs-12 pb-5">
                    <h3>{this.props.CONFIG.question || 'Are you extremely sure about it?'}</h3>
                </div>
                <button className="btn btn-danger mr-4" onClick={() => this.props.CONFIG.onClose()}>{this.props.CONFIG.cancelTitle || 'cancel'}</button>
                <button className="btn btn-primary ml-4" onClick={() => this.onConfirm()}>{this.props.CONFIG.confirmTitle || 'confirm'}</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/__templates/libs/confirm.tsx